import {
  CampaignAutodiscoveryStatus,
  CampaignKeywordsAndTopics,
  CampaignTopic,
  Dynamic1Status,
} from "@intentsify/types";
import { atom } from "jotai";
import { KeywordItem } from "types/Keyword";
import {
  AutodiscoverySettings,
  Dynamic1State,
} from "./KeywordsAndTopicsStep.types";

const keywordsAndTopicsStateAtom = atom<CampaignKeywordsAndTopics>({
  keywords: [],
  topics: [],
  autodiscoveryDescription: "",
  autodiscoveryUrls: [],
  autodiscoveryKeywords: [],
  autodiscoveryTopics: [],
  autodiscoveryProducts: [],
  autodiscoveryStatus: CampaignAutodiscoveryStatus.STATE_UNSPECIFIED,
  autodiscoveryFiles: [],
  dynamicOneStatus: Dynamic1Status.Unspecified,
});

const keywordsAtom = atom<KeywordItem[]>([]);

const isLoadingKeywordsAtom = atom<boolean>(false);

const topicsAtom = atom<CampaignTopic[]>([]);

const isLoadingTopicsAtom = atom<boolean>(false);

const isMutatingAutodiscoveryFilesAtom = atom<boolean>(false);

const autodiscoverySettingsAtom = atom<AutodiscoverySettings>({
  autodiscoveryDescription: "",
  autodiscoveryUrls: [],
  autodiscoveryKeywords: [],
  autodiscoveryTopics: [],
  autodiscoveryProducts: [],
  autodiscoveryStatus: CampaignAutodiscoveryStatus.STATE_UNSPECIFIED,
  autodiscoveryFiles: [],
});

const dynamic1Atom = atom<Dynamic1State>({
  processingStatus: Dynamic1Status.Unspecified,
});

const keywordsAndTopicsStateSelector = atom(
  (get) => get(keywordsAndTopicsStateAtom),
  (_get, set, newValue: CampaignKeywordsAndTopics) => {
    set(keywordsAndTopicsStateAtom, newValue);
  }
);

const keywordsSelector = atom(
  (get) => get(keywordsAtom),
  (_get, set, newValues: KeywordItem[]) => {
    if (newValues.length === 0) {
      set(keywordsAtom, []);
    } else {
      set(
        keywordsAtom,
        newValues.map((v) => ({ ...v, label: v.label.toLowerCase() }))
      );
    }
  }
);

const topicsSelector = atom(
  (get) => get(topicsAtom),
  (_get, set, newValues: CampaignTopic[]) => {
    if (newValues.length === 0) {
      set(topicsAtom, []);
    } else {
      set(topicsAtom, newValues);
    }
  }
);

const topicIdsSelector = atom((get) => get(topicsAtom).map((t) => t.topicId));

const isLoadingKeywordsAndTopicsStepSelector = atom(
  (get) =>
    get(isLoadingKeywordsAtom) ||
    get(isLoadingTopicsAtom) ||
    get(isMutatingAutodiscoveryFilesAtom)
);

const autodiscoverySettingsStateSelector = atom(
  (get) => get(autodiscoverySettingsAtom),
  (_get, set, newValue: AutodiscoverySettings) => {
    set(autodiscoverySettingsAtom, newValue);
  }
);

const dynamic1StateSelector = atom(
  (get) => get(dynamic1Atom),
  (_get, set, newValue: Dynamic1State) => {
    set(dynamic1Atom, { processingStatus: newValue.processingStatus });
  }
);

export {
  autodiscoverySettingsAtom,
  autodiscoverySettingsStateSelector,
  dynamic1StateSelector,
  isLoadingKeywordsAndTopicsStepSelector,
  isLoadingKeywordsAtom,
  isLoadingTopicsAtom,
  isMutatingAutodiscoveryFilesAtom,
  keywordsAndTopicsStateSelector,
  keywordsAtom,
  keywordsSelector,
  topicIdsSelector,
  topicsSelector,
};
